<template>
  <component :is="component" />
</template>

<script>
import terminalGroupBuyCheck from '../components/terminalGroupBuyCheck.vue'
import terminalGroupBuy from '../terminalGroupBuy.vue'
export default {
  components: {
    terminalGroupBuyCheck,
    terminalGroupBuy
  },
  data() {
    return {
      component: 'terminalGroupBuyCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'terminalGroupBuyCheck' : 'terminalGroupBuy'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/order-manage/check/terminalGroupBuyCheck.vue